import { render, staticRenderFns } from "./OrderFlow.vue?vue&type=template&id=87c26808&scoped=true&"
import script from "./OrderFlow.vue?vue&type=script&lang=js&"
export * from "./OrderFlow.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlow.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderFlow.vue?vue&type=style&index=1&id=87c26808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c26808",
  null
  
)

export default component.exports